const About1Content = () => {
  return (
    <div className="w-full h-full rounded-[50px] text-white bg-[#3E3232] py-20 px-5 flex flex-row">
      <div className="flex flex-col gap-y-5 text-[40px] justify-center basis-2/3 ps-12">
        <p>
          To My Dearest Mother,
        </p>
      </div>
    </div>
  );
};

const About2Content = () => {
  return (
    <div className="w-full h-full rounded-[50px] text-white bg-[#3E3232] p-12">
      <p className="hover-highlight text-[28px] border-2 border-[#f6cfcf] rounded-2xl p-7 w-fit h-fit">
        On this special day, I just want to pause and celebrate the incredible woman you are.
        <br /> You’ve been my teacher, my guide, my friend, my home — all wrapped in one beautiful soul.
        <br /> <br /> From your warm hugs to your wise words, every little thing you do fills my life with love and light.
        <br /> <br /> Thank you for being the strongest, kindest, and most inspiring person I know.
        <br /> <br /> Happy Mother’s Day — today and always, I celebrate you.
      </p>
    </div>
  );
};

export { About1Content, About2Content };
